export default "__VITE_ASSET__2e46d67b__"